export default {
  message: {
    "strid1": "Homepage",
    "strid2": "Tutorial",
    "strid3": "Event",
    "strid4": "အဖွဲ့ဝင်လိုက်ပါ",
    "strid5": "Discord",
    "strid6": "Creator Academy",
    "strid7": "​ရွေးချယ်ထား​သောအလုပ်များ",
    "strid8": "ပြန်ထွက်မည်",
    "strid9": "ယခုဘဲပါဝင်လိုက်ပါ",
    "strid10": "More Events",
    "strid11": "ကိုယ်​ရေးအချက်အလက်",
    "strid12": "Game Server",
    "strid13": "သင်၏ Server နံပါတ်ကိုဖြည့်စွက်ရန်",
    "strid14": "Game ID",
    "strid15": "သင့် Game ID ဖြည့်​ပေးရန်",
    "strid16": "Contact Info",
    "strid17": "Platform ​ရွေးချယ်ပါ",
    "strid18": "သင့်ကိုဆက်သွယ်လို့ရမယ့်အချက်အလက်ကိုဖြည့်​ပေးရန်",
    "strid19": "အလုပ်အ​သေးစိတ်",
    "strid20": "Publishing Platform",
    "strid21": "မှန်ကန်​သော Link ထည့်​ပေးပါရန်",
    "strid22": "link အသစ်ထပ်ထည့်ရန်နိပ်ပါ",
    "strid23": "အသုံးပြုထား​သောဘာသာစကား",
    "strid24": "အသုံးပြုထား​သောဘာသာစကားကို​ရွေးချယ်​ပေးပါရန်",
    "strid25": "English",
    "strid26": "Arabic",
    "strid27": "Spanish",
    "strid28": "Portuguese",
    "strid29": "Khmer",
    "strid30": "Burmese",
    "strid31": "Malay",
    "strid32": "အခြား",
    "strid33": "ကျွန်တော်ဟာဒီအလုပ်ကို ပိုင်ဆိုင်သူဖြစ်​ကြောင်းကိုအတည်ပြုပြီး ဒီသဘောတူညီမှုကိုသိရှိပါတယ်။",
    "strid34": "​လျှောက်တင်မည်",
    "strid35": "​လျှောက်တင်ပြီးပါပြီ!",
    "strid36": "အကျိုးကျေးဇူးများ",
    "strid37": "ရရှိရန် အခုပဲကျွန်တော်တို့ကိုဆက်သွယ်ပါ။",
    "strid38": "MLBB official social media မှအားပေးမှု \n",
    "strid39": "Creator interactive community",
    "strid40": "အပတ်စဉ် စိန်ဆုလာဘ်",
    "strid41": "ထပ်ရမည့် အကျိုးကျေးဇူးများ",
    "strid42": "Game Merchandise",
    "strid43": "Offline event များ",
    "strid44": "Skin ပေါင်းမြောက်များစွာ",
    "strid45": "Brand collaboration",
    "strid46": "Ad promotion",
    "strid47": "ကျွန်တော်တို့အဖွဲ့တွင် ပါဝင်လိုက်ပါ",
    "strid48": "လိုအပ်ချက်များ",
    "strid49": "ကျွန်တော်တို့ကို FOLLOW ပါ",
    "strid50": "MLBB official account ကိုကြည့်ဖို့နှိပ်ပါ။",
    "strid51": "သ​ဘောတူညီချက်ဆိုင်ရာအ​ကြောင်းအရာ",
    "strid52": "အကြောင်းအရာ သေချာပြန်စစ်ပါ",
    "strid53": "ပို့ဆောင်မှု အဆင်မပြေပါ",
    "strid54": "သင့္ channel လင့္ခ္ကို ျဖည့္စြက္ပါ။",  // 请输入正确的频道链接
    "strid55": "သင့္ရဲ႕ ႏိုင္ငံကို ေ႐ြးပါ။",
    "strid56": "သင့္ရဲ႕ ႏိုင္ငံ",


  }
}
